// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— Doctor profile (Stitch: Doctor — Dr. Maya Haddad) ——— */
.doctor-profile {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 24px;
}

@media (min-width: 1024px) {
  .doctor-profile {
    padding: 32px;
  }
}

.doctor-profile__inner {
  box-sizing: border-box;
  width: 100%;
  max-width: 72rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

.doctor-profile__inner > .ant-spin-nested-loading,
.doctor-profile__inner > .ant-spin-nested-loading > .ant-spin-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

/* ——— Hero ——— */
.doctor-profile__hero {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 28px;
  margin-bottom: 8px;
  border-bottom: 1px solid #E2E8F0;
}

@media (min-width: 640px) {
  .doctor-profile__hero {
    flex-direction: row;
    align-items: center;
    padding-bottom: 32px;
    margin-bottom: 12px;
  }
}

.doctor-profile__hero-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.doctor-profile__back {
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #ffffff;
  color: #64748B;
  cursor: pointer;
  transition: background 0.12s ease, color 0.12s ease;
}

.doctor-profile__back:hover {
  background: #F8FAFC;
  color: #0F172A;
}

[dir='rtl'] .doctor-profile__back .anticon {
  transform: scaleX(-1);
}

.doctor-profile__hero-text {
  min-width: 0;
}

.doctor-profile__title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.doctor-profile__title-row h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: #0F172A;
}

.doctor-profile__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
}

.doctor-profile__status.is-available {
  border: 1px solid rgba(16, 185, 129, 0.2);
  background: #ECFDF5;
  color: #10B981;
}

.doctor-profile__status.is-archived {
  border: 1px solid #FECACA;
  background: #FEF2F2;
  color: #DC2626;
}

.doctor-profile__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
}

.doctor-profile__subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  line-height: 18px;
  color: #64748B;
}

.doctor-profile__hero-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  flex-shrink: 0;
}

.doctor-profile__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.doctor-profile__btn--secondary {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #0F172A;
}

.doctor-profile__btn--secondary:hover {
  background: #F8FAFC;
}

.doctor-profile__btn--secondary .anticon {
  font-size: 15px;
  color: #64748B;
}

.doctor-profile__btn--primary {
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
}

.doctor-profile__btn--primary:hover {
  background: #0284C7;
  border-color: #0284C7;
}

.doctor-profile__btn--primary .anticon {
  font-size: 15px;
}

/* ——— Cards grid (Personal | Contact | Capacity) ——— */
.doctor-profile__cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  min-width: 0;
}

@media (min-width: 768px) {
  .doctor-profile__cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
  }

  .doctor-profile__cards > .doctor-capacity {
    grid-column: 1 / -1;
  }
}

@media (min-width: 1100px) {
  .doctor-profile__cards {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .doctor-profile__cards > .doctor-capacity {
    grid-column: auto;
  }
}

.doctor-profile__card {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 20px;
  min-width: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.doctor-profile__card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid #F1F5F9;
}

.doctor-profile__card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.doctor-profile__card-title h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
}

.doctor-profile__card-icon {
  color: #0EA5E9;
  font-size: 18px;
  line-height: 1;
}

.doctor-profile__id-badge {
  flex-shrink: 0;
  max-width: 55%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 2px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  background: #F8FAFC;
  font-size: 11px;
  font-weight: 500;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #64748B;
}

.doctor-profile__verified {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid rgba(16, 185, 129, 0.2);
  background: #ECFDF5;
  color: #10B981;
  font-size: 11px;
  font-weight: 600;
}

.doctor-profile__verified .anticon {
  font-size: 12px;
}

.doctor-profile__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 16px;
  row-gap: 20px;
  margin: 0;
  font-size: 13px;
}

.doctor-profile__grid > div.is-full {
  grid-column: 1 / -1;
  padding-top: 8px;
  border-top: 1px solid #F8FAFC;
}

.doctor-profile__grid dt {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.doctor-profile__grid dd {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #0F172A;
  line-height: 1.45;
}

.doctor-profile__grid dd .is-mono,
.doctor-profile__grid dd.is-mono,
.doctor-profile__contact-row dd.is-mono,
.doctor-capacity .is-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
}

.doctor-profile__address {
  display: flex;
  align-items: center;
  gap: 6px;
}

.doctor-profile__address .anticon {
  color: #94A3B8;
  font-size: 15px;
  flex-shrink: 0;
}

.doctor-profile__contact-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 0;
  font-size: 13px;
}

.doctor-profile__contact-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 4px 0;
  border-bottom: 1px solid #F8FAFC;
}

.doctor-profile__contact-row.is-last {
  border-bottom: none;
}

.doctor-profile__contact-row dt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.doctor-profile__contact-row dt .anticon {
  font-size: 15px;
  color: #94A3B8;
}

.doctor-profile__contact-row dd {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #0F172A;
  text-align: right;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

[dir='rtl'] .doctor-profile__contact-row dd {
  text-align: left;
}

/* ——— Capacity card ——— */
.doctor-capacity__badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.doctor-capacity__badge.is-ok {
  border: 1px solid rgba(16, 185, 129, 0.2);
  background: #ECFDF5;
  color: #10B981;
}

.doctor-capacity__badge.is-idle {
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  color: #64748B;
}

.doctor-capacity__badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
}

.doctor-capacity__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  font-size: 13px;
}

.doctor-capacity__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.doctor-capacity__row dt {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.doctor-capacity__row dt .anticon {
  font-size: 15px;
  color: #94A3B8;
}

.doctor-capacity__row dd {
  margin: 0;
  font-weight: 500;
  color: #0F172A;
  text-align: end;
}

.doctor-capacity .is-strong {
  font-weight: 600;
}

.doctor-capacity .is-sky,
.doctor-schedules .is-sky {
  color: #0EA5E9;
}

.doctor-capacity .is-muted,
.doctor-schedules .is-muted {
  color: #64748B;
  font-weight: 400;
  font-size: 11px;
}

.doctor-capacity__load {
  padding-top: 8px;
  border-top: 1px solid #F8FAFC;
}

.doctor-capacity__load-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.doctor-capacity__load-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 400;
  color: #64748B;
}

.doctor-capacity__load-legend .is-sep {
  color: #94A3B8;
}

.doctor-capacity__bar {
  display: flex;
  width: 100%;
  height: 8px;
  border-radius: 9999px;
  overflow: hidden;
  background: #F1F5F9;
}

.doctor-capacity__bar-seg {
  display: block;
  height: 100%;
}

.doctor-capacity__bar-seg.is-online {
  background: #0EA5E9;
}

.doctor-capacity__bar-seg.is-clinic {
  background: #10B981;
}

.doctor-capacity__bar-seg.is-empty {
  background: #E2E8F0;
}

/* ——— Schedules ——— */
.doctor-schedules {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 20px;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

@media (min-width: 640px) {
  .doctor-schedules {
    margin-top: 16px;
  }
}

.doctor-schedules__head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #F1F5F9;
}

@media (min-width: 640px) {
  .doctor-schedules__head {
    flex-direction: row;
    align-items: center;
  }
}

.doctor-schedules__title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}

.doctor-schedules__title h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
}

.doctor-schedules__title-icon {
  color: #0EA5E9;
  font-size: 18px;
}

.doctor-schedules__count {
  margin-inline-start: 4px;
  padding: 2px 8px;
  border-radius: 9999px;
  background: #F1F5F9;
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
}

.doctor-schedules__summary {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  padding: 14px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  background: #F8FAFC;
}

@media (min-width: 768px) {
  .doctor-schedules__summary {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0;
  }
}

.doctor-schedules__summary-item {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding-top: 8px;
  border-top: 1px solid #E2E8F0;
}

.doctor-schedules__summary-item:first-child {
  padding-top: 0;
  border-top: none;
}

@media (min-width: 768px) {
  .doctor-schedules__summary-item {
    padding-top: 0;
    padding-inline-start: 16px;
    border-top: none;
    border-inline-start: 1px solid #E2E8F0;
  }

  .doctor-schedules__summary-item:first-child {
    padding-inline-start: 0;
    border-inline-start: none;
  }
}

.doctor-schedules__summary-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 16px;
}

.doctor-schedules__summary-icon.is-sky {
  background: #E0F2FE;
  color: #0EA5E9;
}

.doctor-schedules__summary-icon.is-emerald {
  background: #ECFDF5;
  color: #10B981;
}

.doctor-schedules__summary-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
}

.doctor-schedules__summary-value {
  margin-top: 2px;
  font-size: 14px;
  font-weight: 700;
  color: #0F172A;
  line-height: 1.3;
}

.doctor-schedules__summary-value.is-facility {
  font-size: 13px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.doctor-schedules__body {
  min-width: 0;
}

.doctor-schedules__table-wrap {
  overflow-x: auto;
  min-width: 0;
}

.doctor-schedules__table {
  width: 100%;
  border-collapse: collapse;
  text-align: start;
  font-size: 13px;
}

.doctor-schedules__table thead th {
  padding: 10px 12px;
  border-bottom: 1px solid #E2E8F0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748B;
  white-space: nowrap;
  text-align: start; /* override UA <th> center alignment */
}

.doctor-schedules__table thead th.is-actions {
  text-align: end;
}

.doctor-schedules__table tbody tr {
  transition: background 0.12s ease;
}

.doctor-schedules__table tbody tr:hover {
  background: #F8FAFC;
}

.doctor-schedules__table tbody td {
  padding: 14px 12px;
  border-bottom: 1px solid #F1F5F9;
  color: #475569;
  vertical-align: middle;
}

.doctor-schedules__table tbody tr:last-child td {
  border-bottom: none;
}

.doctor-schedules__day {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #0F172A;
}

.doctor-schedules__day-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #0EA5E9;
  flex-shrink: 0;
}

.doctor-schedules__shift-name {
  font-weight: 500;
  color: #0F172A;
}

.doctor-schedules__shift-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
  flex-wrap: wrap;
}

.doctor-schedules__time {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: #475569;
}

.doctor-schedules__duration {
  padding: 2px 6px;
  border-radius: 4px;
  background: #F1F5F9;
  font-size: 10px;
  font-weight: 600;
  color: #64748B;
}

.doctor-schedules__room {
  font-weight: 500;
  color: #0F172A;
}

.doctor-schedules__clinic {
  margin-top: 2px;
  font-size: 12px;
  color: #64748B;
}

.doctor-schedules__quota-text {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  font-weight: 500;
  color: #0F172A;
}

.doctor-schedules__quota-text .is-sep {
  color: #94A3B8;
}

.doctor-schedules__quota-text .is-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
}

.doctor-schedules__quota-text .is-strong {
  font-weight: 600;
}

.doctor-schedules__quota-bar {
  display: flex;
  width: 8rem;
  max-width: 100%;
  height: 6px;
  margin-top: 6px;
  border-radius: 9999px;
  overflow: hidden;
  background: #F1F5F9;
}

.doctor-schedules__quota-bar .is-online {
  background: #0EA5E9;
}

.doctor-schedules__quota-bar .is-clinic {
  background: #94A3B8;
}

.doctor-schedules__channels {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.doctor-schedules__channel {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
}

.doctor-schedules__channel.is-online {
  color: #0EA5E9;
}

.doctor-schedules__channel.is-clinic-only {
  color: #64748B;
}

.doctor-schedules__channel .anticon {
  font-size: 13px;
}

.doctor-schedules__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
}

.doctor-schedules__status.is-active {
  border: 1px solid rgba(16, 185, 129, 0.2);
  background: #ECFDF5;
  color: #10B981;
}

.doctor-schedules__status.is-inactive {
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  color: #64748B;
}

.doctor-schedules__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
}

.doctor-schedules__actions {
  text-align: end;
  white-space: nowrap;
  vertical-align: middle;
}

.doctor-schedules__action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #0369A1;
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
}

.doctor-schedules__action:hover {
  background: #F0F9FF;
  color: #0284C7;
}

.doctor-schedules__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  color: #64748B;
  font-size: 13px;
}

.doctor-schedules__pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 4px;
}

.doctor-schedules__pager-btn {
  height: 28px;
  padding: 0 10px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  background: #ffffff;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  color: #334155;
  cursor: pointer;
}

.doctor-schedules__pager-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.doctor-schedules__pager-label {
  font-size: 12px;
  color: #64748B;
  font-variant-numeric: tabular-nums;
}

@media (max-width: 640px) {
  .doctor-profile {
    padding: 16px;
  }

  .doctor-profile__inner,
  .doctor-profile__inner > .ant-spin-nested-loading,
  .doctor-profile__inner > .ant-spin-nested-loading > .ant-spin-container {
    gap: 20px;
  }

  .doctor-profile__hero {
    padding-bottom: 24px;
    margin-bottom: 4px;
  }

  .doctor-profile__title-row h1 {
    font-size: 20px;
  }

  .doctor-profile__hero-actions {
    width: 100%;
  }

  .doctor-profile__hero-actions .doctor-profile__btn {
    flex: 1 1 auto;
  }

  .doctor-profile__card {
    padding: 16px;
  }

  .doctor-profile__grid {
    grid-template-columns: 1fr;
  }

  .doctor-profile__id-badge {
    max-width: 42%;
  }

  .doctor-schedules {
    padding: 16px;
  }

  .doctor-schedules__quota-bar {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .doctor-profile__contact-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    padding: 8px 0;
  }

  .doctor-profile__contact-row dd {
    text-align: start;
  }

  .doctor-capacity__row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .doctor-capacity__row dd {
    text-align: start;
  }
}

@media print {
  .doctor-profile__back,
  .doctor-profile__hero-actions,
  .doctor-schedules__head .doctor-profile__btn,
  .doctor-schedules__actions,
  .doctor-schedules__pager {
    display: none !important;
  }

  .doctor-profile {
    padding: 0;
  }

  .doctor-profile__card,
  .doctor-schedules {
    box-shadow: none;
    break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowDoctor/style.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,YAAY;AACd;;AAEA;EACE;IACE,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,6EAA6E;EAC7E,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;EAIE,6EAA6E;EAC7E,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;IAChD,MAAM;EACR;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;IAChB,sCAAsC;EACxC;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,iBAAiB,EAAE,sCAAsC;AAC3D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;;;;;IAKE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;IAChB,mBAAmB;EACrB;AACF","sourcesContent":["/* ——— Doctor profile (Stitch: Doctor — Dr. Maya Haddad) ——— */\n.doctor-profile {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 24px;\n}\n\n@media (min-width: 1024px) {\n  .doctor-profile {\n    padding: 32px;\n  }\n}\n\n.doctor-profile__inner {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 72rem;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n}\n\n.doctor-profile__inner > .ant-spin-nested-loading,\n.doctor-profile__inner > .ant-spin-nested-loading > .ant-spin-container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-width: 0;\n}\n\n/* ——— Hero ——— */\n.doctor-profile__hero {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: space-between;\n  gap: 16px;\n  padding-bottom: 28px;\n  margin-bottom: 8px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n@media (min-width: 640px) {\n  .doctor-profile__hero {\n    flex-direction: row;\n    align-items: center;\n    padding-bottom: 32px;\n    margin-bottom: 12px;\n  }\n}\n\n.doctor-profile__hero-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.doctor-profile__back {\n  box-sizing: border-box;\n  width: 36px;\n  height: 36px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #64748B;\n  cursor: pointer;\n  transition: background 0.12s ease, color 0.12s ease;\n}\n\n.doctor-profile__back:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n[dir='rtl'] .doctor-profile__back .anticon {\n  transform: scaleX(-1);\n}\n\n.doctor-profile__hero-text {\n  min-width: 0;\n}\n\n.doctor-profile__title-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.doctor-profile__title-row h1 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: #0F172A;\n}\n\n.doctor-profile__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.doctor-profile__status.is-available {\n  border: 1px solid rgba(16, 185, 129, 0.2);\n  background: #ECFDF5;\n  color: #10B981;\n}\n\n.doctor-profile__status.is-archived {\n  border: 1px solid #FECACA;\n  background: #FEF2F2;\n  color: #DC2626;\n}\n\n.doctor-profile__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n}\n\n.doctor-profile__subtitle {\n  margin: 2px 0 0;\n  font-size: 13px;\n  line-height: 18px;\n  color: #64748B;\n}\n\n.doctor-profile__hero-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n}\n\n.doctor-profile__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.doctor-profile__btn--secondary {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #0F172A;\n}\n\n.doctor-profile__btn--secondary:hover {\n  background: #F8FAFC;\n}\n\n.doctor-profile__btn--secondary .anticon {\n  font-size: 15px;\n  color: #64748B;\n}\n\n.doctor-profile__btn--primary {\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n}\n\n.doctor-profile__btn--primary:hover {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n.doctor-profile__btn--primary .anticon {\n  font-size: 15px;\n}\n\n/* ——— Cards grid (Personal | Contact | Capacity) ——— */\n.doctor-profile__cards {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  min-width: 0;\n}\n\n@media (min-width: 768px) {\n  .doctor-profile__cards {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 20px;\n  }\n\n  .doctor-profile__cards > .doctor-capacity {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (min-width: 1100px) {\n  .doctor-profile__cards {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .doctor-profile__cards > .doctor-capacity {\n    grid-column: auto;\n  }\n}\n\n.doctor-profile__card {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 20px;\n  min-width: 0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.doctor-profile__card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 12px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.doctor-profile__card-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.doctor-profile__card-title h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n}\n\n.doctor-profile__card-icon {\n  color: #0EA5E9;\n  font-size: 18px;\n  line-height: 1;\n}\n\n.doctor-profile__id-badge {\n  flex-shrink: 0;\n  max-width: 55%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 2px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  background: #F8FAFC;\n  font-size: 11px;\n  font-weight: 500;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #64748B;\n}\n\n.doctor-profile__verified {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  border: 1px solid rgba(16, 185, 129, 0.2);\n  background: #ECFDF5;\n  color: #10B981;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.doctor-profile__verified .anticon {\n  font-size: 12px;\n}\n\n.doctor-profile__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 16px;\n  row-gap: 20px;\n  margin: 0;\n  font-size: 13px;\n}\n\n.doctor-profile__grid > div.is-full {\n  grid-column: 1 / -1;\n  padding-top: 8px;\n  border-top: 1px solid #F8FAFC;\n}\n\n.doctor-profile__grid dt {\n  margin: 0 0 8px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.doctor-profile__grid dd {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0F172A;\n  line-height: 1.45;\n}\n\n.doctor-profile__grid dd .is-mono,\n.doctor-profile__grid dd.is-mono,\n.doctor-profile__contact-row dd.is-mono,\n.doctor-capacity .is-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n}\n\n.doctor-profile__address {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.doctor-profile__address .anticon {\n  color: #94A3B8;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n\n.doctor-profile__contact-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin: 0;\n  font-size: 13px;\n}\n\n.doctor-profile__contact-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 4px 0;\n  border-bottom: 1px solid #F8FAFC;\n}\n\n.doctor-profile__contact-row.is-last {\n  border-bottom: none;\n}\n\n.doctor-profile__contact-row dt {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.doctor-profile__contact-row dt .anticon {\n  font-size: 15px;\n  color: #94A3B8;\n}\n\n.doctor-profile__contact-row dd {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0F172A;\n  text-align: right;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n[dir='rtl'] .doctor-profile__contact-row dd {\n  text-align: left;\n}\n\n/* ——— Capacity card ——— */\n.doctor-capacity__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.doctor-capacity__badge.is-ok {\n  border: 1px solid rgba(16, 185, 129, 0.2);\n  background: #ECFDF5;\n  color: #10B981;\n}\n\n.doctor-capacity__badge.is-idle {\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  color: #64748B;\n}\n\n.doctor-capacity__badge-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n}\n\n.doctor-capacity__list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 0;\n  font-size: 13px;\n}\n\n.doctor-capacity__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.doctor-capacity__row dt {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.doctor-capacity__row dt .anticon {\n  font-size: 15px;\n  color: #94A3B8;\n}\n\n.doctor-capacity__row dd {\n  margin: 0;\n  font-weight: 500;\n  color: #0F172A;\n  text-align: end;\n}\n\n.doctor-capacity .is-strong {\n  font-weight: 600;\n}\n\n.doctor-capacity .is-sky,\n.doctor-schedules .is-sky {\n  color: #0EA5E9;\n}\n\n.doctor-capacity .is-muted,\n.doctor-schedules .is-muted {\n  color: #64748B;\n  font-weight: 400;\n  font-size: 11px;\n}\n\n.doctor-capacity__load {\n  padding-top: 8px;\n  border-top: 1px solid #F8FAFC;\n}\n\n.doctor-capacity__load-head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.doctor-capacity__load-legend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  text-transform: none;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: #64748B;\n}\n\n.doctor-capacity__load-legend .is-sep {\n  color: #94A3B8;\n}\n\n.doctor-capacity__bar {\n  display: flex;\n  width: 100%;\n  height: 8px;\n  border-radius: 9999px;\n  overflow: hidden;\n  background: #F1F5F9;\n}\n\n.doctor-capacity__bar-seg {\n  display: block;\n  height: 100%;\n}\n\n.doctor-capacity__bar-seg.is-online {\n  background: #0EA5E9;\n}\n\n.doctor-capacity__bar-seg.is-clinic {\n  background: #10B981;\n}\n\n.doctor-capacity__bar-seg.is-empty {\n  background: #E2E8F0;\n}\n\n/* ——— Schedules ——— */\n.doctor-schedules {\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  padding: 20px;\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-width: 0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n@media (min-width: 640px) {\n  .doctor-schedules {\n    margin-top: 16px;\n  }\n}\n\n.doctor-schedules__head {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n@media (min-width: 640px) {\n  .doctor-schedules__head {\n    flex-direction: row;\n    align-items: center;\n  }\n}\n\n.doctor-schedules__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.doctor-schedules__title h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n}\n\n.doctor-schedules__title-icon {\n  color: #0EA5E9;\n  font-size: 18px;\n}\n\n.doctor-schedules__count {\n  margin-inline-start: 4px;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  background: #F1F5F9;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n}\n\n.doctor-schedules__summary {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n  padding: 14px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  background: #F8FAFC;\n}\n\n@media (min-width: 768px) {\n  .doctor-schedules__summary {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 0;\n  }\n}\n\n.doctor-schedules__summary-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n  padding-top: 8px;\n  border-top: 1px solid #E2E8F0;\n}\n\n.doctor-schedules__summary-item:first-child {\n  padding-top: 0;\n  border-top: none;\n}\n\n@media (min-width: 768px) {\n  .doctor-schedules__summary-item {\n    padding-top: 0;\n    padding-inline-start: 16px;\n    border-top: none;\n    border-inline-start: 1px solid #E2E8F0;\n  }\n\n  .doctor-schedules__summary-item:first-child {\n    padding-inline-start: 0;\n    border-inline-start: none;\n  }\n}\n\n.doctor-schedules__summary-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 16px;\n}\n\n.doctor-schedules__summary-icon.is-sky {\n  background: #E0F2FE;\n  color: #0EA5E9;\n}\n\n.doctor-schedules__summary-icon.is-emerald {\n  background: #ECFDF5;\n  color: #10B981;\n}\n\n.doctor-schedules__summary-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n}\n\n.doctor-schedules__summary-value {\n  margin-top: 2px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.doctor-schedules__summary-value.is-facility {\n  font-size: 13px;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.doctor-schedules__body {\n  min-width: 0;\n}\n\n.doctor-schedules__table-wrap {\n  overflow-x: auto;\n  min-width: 0;\n}\n\n.doctor-schedules__table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: start;\n  font-size: 13px;\n}\n\n.doctor-schedules__table thead th {\n  padding: 10px 12px;\n  border-bottom: 1px solid #E2E8F0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748B;\n  white-space: nowrap;\n  text-align: start; /* override UA <th> center alignment */\n}\n\n.doctor-schedules__table thead th.is-actions {\n  text-align: end;\n}\n\n.doctor-schedules__table tbody tr {\n  transition: background 0.12s ease;\n}\n\n.doctor-schedules__table tbody tr:hover {\n  background: #F8FAFC;\n}\n\n.doctor-schedules__table tbody td {\n  padding: 14px 12px;\n  border-bottom: 1px solid #F1F5F9;\n  color: #475569;\n  vertical-align: middle;\n}\n\n.doctor-schedules__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.doctor-schedules__day {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.doctor-schedules__day-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #0EA5E9;\n  flex-shrink: 0;\n}\n\n.doctor-schedules__shift-name {\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.doctor-schedules__shift-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 2px;\n  flex-wrap: wrap;\n}\n\n.doctor-schedules__time {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  color: #475569;\n}\n\n.doctor-schedules__duration {\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: #F1F5F9;\n  font-size: 10px;\n  font-weight: 600;\n  color: #64748B;\n}\n\n.doctor-schedules__room {\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.doctor-schedules__clinic {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #64748B;\n}\n\n.doctor-schedules__quota-text {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n  font-weight: 500;\n  color: #0F172A;\n}\n\n.doctor-schedules__quota-text .is-sep {\n  color: #94A3B8;\n}\n\n.doctor-schedules__quota-text .is-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n}\n\n.doctor-schedules__quota-text .is-strong {\n  font-weight: 600;\n}\n\n.doctor-schedules__quota-bar {\n  display: flex;\n  width: 8rem;\n  max-width: 100%;\n  height: 6px;\n  margin-top: 6px;\n  border-radius: 9999px;\n  overflow: hidden;\n  background: #F1F5F9;\n}\n\n.doctor-schedules__quota-bar .is-online {\n  background: #0EA5E9;\n}\n\n.doctor-schedules__quota-bar .is-clinic {\n  background: #94A3B8;\n}\n\n.doctor-schedules__channels {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.doctor-schedules__channel {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.doctor-schedules__channel.is-online {\n  color: #0EA5E9;\n}\n\n.doctor-schedules__channel.is-clinic-only {\n  color: #64748B;\n}\n\n.doctor-schedules__channel .anticon {\n  font-size: 13px;\n}\n\n.doctor-schedules__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 8px;\n  border-radius: 9999px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.doctor-schedules__status.is-active {\n  border: 1px solid rgba(16, 185, 129, 0.2);\n  background: #ECFDF5;\n  color: #10B981;\n}\n\n.doctor-schedules__status.is-inactive {\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  color: #64748B;\n}\n\n.doctor-schedules__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n}\n\n.doctor-schedules__actions {\n  text-align: end;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.doctor-schedules__action {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 28px;\n  padding: 0 8px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #0369A1;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.doctor-schedules__action:hover {\n  background: #F0F9FF;\n  color: #0284C7;\n}\n\n.doctor-schedules__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n  color: #64748B;\n  font-size: 13px;\n}\n\n.doctor-schedules__pager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding-top: 4px;\n}\n\n.doctor-schedules__pager-btn {\n  height: 28px;\n  padding: 0 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  background: #ffffff;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  color: #334155;\n  cursor: pointer;\n}\n\n.doctor-schedules__pager-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.doctor-schedules__pager-label {\n  font-size: 12px;\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n}\n\n@media (max-width: 640px) {\n  .doctor-profile {\n    padding: 16px;\n  }\n\n  .doctor-profile__inner,\n  .doctor-profile__inner > .ant-spin-nested-loading,\n  .doctor-profile__inner > .ant-spin-nested-loading > .ant-spin-container {\n    gap: 20px;\n  }\n\n  .doctor-profile__hero {\n    padding-bottom: 24px;\n    margin-bottom: 4px;\n  }\n\n  .doctor-profile__title-row h1 {\n    font-size: 20px;\n  }\n\n  .doctor-profile__hero-actions {\n    width: 100%;\n  }\n\n  .doctor-profile__hero-actions .doctor-profile__btn {\n    flex: 1 1 auto;\n  }\n\n  .doctor-profile__card {\n    padding: 16px;\n  }\n\n  .doctor-profile__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .doctor-profile__id-badge {\n    max-width: 42%;\n  }\n\n  .doctor-schedules {\n    padding: 16px;\n  }\n\n  .doctor-schedules__quota-bar {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .doctor-profile__contact-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    padding: 8px 0;\n  }\n\n  .doctor-profile__contact-row dd {\n    text-align: start;\n  }\n\n  .doctor-capacity__row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n\n  .doctor-capacity__row dd {\n    text-align: start;\n  }\n}\n\n@media print {\n  .doctor-profile__back,\n  .doctor-profile__hero-actions,\n  .doctor-schedules__head .doctor-profile__btn,\n  .doctor-schedules__actions,\n  .doctor-schedules__pager {\n    display: none !important;\n  }\n\n  .doctor-profile {\n    padding: 0;\n  }\n\n  .doctor-profile__card,\n  .doctor-schedules {\n    box-shadow: none;\n    break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
